import { ls } from '@/utils/db'
// 是否mock接口
export const MSW_SERVICE_KEY = 'msw_mock';
export const MOCK_SERVICE = ls.get(MSW_SERVICE_KEY);

// 页头高度
export const PAGE_HEADER_HEIGHT = 120;

// 页面最小高度
export const MIN_PAGE_HEIGHT = 600;

// Table 组件最小高度，此高度可展示 8 行元素
export const MIN_TABLE_HEIGHT = 408;

// Table 默认每页条数
export const DEFAULT_PAGE_SIZE = 100;
// Drawer 内 Table 默认的每页条数
export const DEFAULT_DRAWER_PAGE_SIZE = 30;

/** Table Popover 默认显示位置 */
export const DEFAULT_TABLE_POPOVER_PLACEMENT = 'topStart';
// Table 默认参数
export const DEFAULT_TABLE_PARAMS = {
  page: 1,
};
export const DEFAULT_TABLE_VALUE = {
  content_list: [],
  current_page: 1,
  last_page: 0,
  total: 0
}
// Pagination分页器 默认限制
export const DEFAULT_PAGINATION_LIMIT = 20;

// Table 中的 Tooltips 延迟展示的时间
export const TABLE_TOOLTIPS_DELAY_SHOW_TIME = 200;

export const TABLE_LENGTH_MENU_ITEMS = [
  {
    value: 30,
    label: 30,
  },
  {
    value: 50,
    label: 50,
  },
  {
    value: DEFAULT_PAGE_SIZE,
    label: DEFAULT_PAGE_SIZE,
  },
];

/**
 * 表单的默认显示 /
 */
export const FORM_DEFAULT_DISPLAY = '/';

/**
 * 表格默认显示 --
 */
export const TABLE_DEFAULT_DISPLAY = '--';

/**
 * loading状态防抖默认的间隔时间 300毫秒
 */
export const DEFAULT_LOADING_DEBOUNCE_TIME = 300;
